import path from 'node:path'
import { resolveExtensionNamespace } from './resolve-extension-namespace.js'

export function resolveSchemaActionDir(
  actionsDir: string,
  schemaName: string,
  outputNamespace?: string
): string {
  const namespace = resolveExtensionNamespace(schemaName, outputNamespace)
  if (namespace === 'core') {
    return path.posix.join(actionsDir, schemaName)
  }

  return namespace === schemaName
    ? path.posix.join(actionsDir, schemaName)
    : path.posix.join(actionsDir, namespace, schemaName)
}
